module.exports = __webpack_public_path__ + "static/easiest-to-do-bussiness-with-dd6da77e07575bb228e0ff9cb51af0d3.svg";